// extracted by mini-css-extract-plugin
export default {"select":"SuperSelect_select__P0jr2","option":"SuperSelect_option__gaxm1"};